// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3b7b2574","977":"29ae6f6a"}[chunkId] + ".chunk.js";
};